document.addEventListener("DOMContentLoaded", function () {

  const totalPrice = document.getElementById("fbt-total-price");
  const savePrice = document.getElementById("fbt-total-save");
  const addBtn = document.getElementById("fbt-add-all");

  if (!totalPrice || !addBtn) return;

  function formatMoney(cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateTotal() {

    let total = 0;
    let compare = 0;

    document.querySelectorAll(".fbt-checkbox:checked").forEach(function (item) {

      const price = Number(item.dataset.price || 0);
      const comparePrice = Number(item.dataset.compare || price);

      total += price;
      compare += comparePrice;

    });

    totalPrice.innerHTML = formatMoney(total);

    if (savePrice) {
      const save = Math.max(compare - total, 0);
      savePrice.innerHTML = formatMoney(save);
    }

  }

  updateTotal();

  document.querySelectorAll(".fbt-checkbox").forEach(function (item) {
    item.addEventListener("change", updateTotal);
  });

  addBtn.addEventListener("click", function () {

    let items = [];

    document.querySelectorAll(".fbt-checkbox:checked").forEach(function (item) {

      items.push({
        id: Number(item.value),
        quantity: 1
      });

    });

    if (items.length === 0) {
      alert("Please select at least one product.");
      return;
    }

    addBtn.disabled = true;
    addBtn.innerHTML = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: items
      })
    })
    .then(function(response) {

      if (!response.ok) {
        throw new Error("Cart Error");
      }

      return response.json();

    })
    .then(function() {

      addBtn.innerHTML = "Added ✓";

      // Refresh cart sections (Dawn compatible)
      fetch("/cart.js")
        .then(function() {

          const cartDrawer = document.querySelector("cart-drawer");

          if (cartDrawer) {

            fetch("/?section_id=cart-drawer")
              .then(response => response.text())
              .then(html => {

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const newDrawer = doc.querySelector("cart-drawer");

                if (newDrawer) {
                  cartDrawer.innerHTML = newDrawer.innerHTML;
                }

                if (typeof cartDrawer.open === "function") {
                  cartDrawer.open();
                } else {
                  cartDrawer.setAttribute("open", "");
                }

                addBtn.disabled = false;
                addBtn.innerHTML = "Add Selected To Cart";

              })
              .catch(function() {

                window.location.href = "/cart";

              });

          } else {

            // Theme doesn't have Cart Drawer
            window.location.href = "/cart";

          }

        });

    })
    .catch(function(error) {

      console.error(error);

      alert("Something went wrong while adding products.");

      addBtn.disabled = false;
      addBtn.innerHTML = "Add Selected To Cart";

    });

  });

});